var map = {
	"./locale-provider/bg_BG.tsx": 934,
	"./locale-provider/ca_ES.tsx": 935,
	"./locale-provider/cs_CZ.tsx": 936,
	"./locale-provider/de_DE.tsx": 937,
	"./locale-provider/el_GR.tsx": 938,
	"./locale-provider/en_GB.tsx": 939,
	"./locale-provider/en_US.tsx": 940,
	"./locale-provider/es_ES.tsx": 941,
	"./locale-provider/et_EE.tsx": 942,
	"./locale-provider/fa_IR.tsx": 943,
	"./locale-provider/fi_FI.tsx": 944,
	"./locale-provider/fr_BE.tsx": 945,
	"./locale-provider/fr_FR.tsx": 946,
	"./locale-provider/it_IT.tsx": 947,
	"./locale-provider/ja_JP.tsx": 948,
	"./locale-provider/ko_KR.tsx": 949,
	"./locale-provider/nb_NO.tsx": 950,
	"./locale-provider/nl_BE.tsx": 951,
	"./locale-provider/nl_NL.tsx": 952,
	"./locale-provider/pl_PL.tsx": 953,
	"./locale-provider/pt_BR.tsx": 954,
	"./locale-provider/pt_PT.tsx": 955,
	"./locale-provider/ru_RU.tsx": 956,
	"./locale-provider/sk_SK.tsx": 957,
	"./locale-provider/sr_RS.tsx": 958,
	"./locale-provider/sv_SE.tsx": 960,
	"./locale-provider/th_TH.tsx": 961,
	"./locale-provider/tr_TR.tsx": 962,
	"./locale-provider/vi_VN.tsx": 963,
	"./locale-provider/zh_TW.tsx": 964
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 884;



//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 884
// module chunks = 0